module.exports = __webpack_public_path__ + "media/images/athletes/3582-397ecc6f61fe481e89d8c8d49e4e165f.png";